<!-- ── Mobile view ─────────────────────────────────────────── -->
<div *ngIf="useMobileView">

  <div class="srch-mob-toolbar">
    <div class="srch-mob-toolbar-inner">
      <div class="srch-mob-title-wrap">
        <span class="srch-mob-title">Search Results</span>
        <span *ngIf="searchCritera" class="srch-mob-criteria">&ldquo;{{searchCritera}}&rdquo;</span>
      </div>
      <button pButton type="button"
              class="p-button-sm p-button-outlined srch-mob-icon-btn"
              [label]="showDisabled ? 'Hide Disabled' : 'Show Disabled'"
              (click)="mobileToggleDisabled()">
      </button>
    </div>
  </div>

  <div *ngIf="!ListBookings || ListBookings.length === 0" style="padding: 2rem; text-align:center; color:#64748b;">
    No bookings found.
  </div>

  <div class="surface-card shadow-2" *ngIf="ListBookings && ListBookings.length > 0">
    <p-table [value]="ListBookings"
             sortField="startTime"
             [paginator]="true" [rows]="10"
             [showCurrentPageReport]="true"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
             [rowsPerPageOptions]="[10,25,50]"
             [globalFilterFields]="['name','bookingId','bookingIdHR','packageName']"
             responsiveLayout="scroll"
             styleClass="mob-booking-table">

      <ng-template pTemplate="header">
        <tr>
          <th class="mob-stripe-th"></th>
          <th pSortableColumn="startTime">Booking</th>
          <th pSortableColumn="total" style="text-align:right">Amount</th>
          <th style="width:48px"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-data>
        <tr [ngStyle]="{'background-color': data.disabled ? '#fff1f2' : '#ffffff'}"
            class="mob-data-row"
            (click)="editdatanew(data.bookingId)">

          <td class="mob-status-stripe"
              [ngStyle]="{'background-color': data.disabled ? '#ef4444' : '#94a3b8'}">
          </td>

          <td class="mob-main-cell">
            <div class="mob-main-line1">
              <span class="mob-time">{{data.startTime | date:'dd/MM' : 'UTC'}}&nbsp;<span style="font-weight:400; color:#64748b;">{{data.startTime | date:'HH:mm' : 'UTC'}}</span></span>
              <span class="mob-name">{{data.name}}</span>
              <span class="mob-inline-icons">
                <i *ngIf="data.publicBooking"   class="pi pi-user              mob-iico"></i>
                <i *ngIf="data.awaitingpayment" class="pi pi-dollar            mob-iico mob-iico--red" pTooltip="Payment link sent"></i>
                <i *ngIf="data.notes"           class="pi pi-exclamation-circle mob-iico mob-iico--red" [pTooltip]="data.notes"></i>
                <i *ngIf="data.seriesid"        class="pi pi-sync              mob-iico" pTooltip="One of a series of repeat bookings"></i>
              </span>
            </div>
            <div class="mob-main-line2">
              <span class="mob-bookingid">{{data.bookingIdHR}}</span>
              <span class="mob-pkg" *ngIf="data.packageName">&nbsp;&middot;&nbsp;{{data.packageName}}</span>
              <span class="mob-guests" *ngIf="data.guests">&nbsp;&middot;&nbsp;{{data.guests}} guest{{data.guests != 1 ? 's' : ''}}</span>
            </div>
          </td>

          <td class="mob-money-cell">
            <div class="mob-total">{{data.total | currency: (data.currency || CurrencySymbol)}}</div>
            <div [class.mob-os--overdue]="data.outstanding > 0" [class.mob-os--paid]="data.outstanding <= 0">
              {{data.outstanding | currency: (data.currency || CurrencySymbol)}}
            </div>
          </td>

          <td class="mob-action-cell" (click)="$event.stopPropagation()">
            <button pButton type="button"
                    class="p-button-text p-button-plain mob-action-btn"
                    icon="pi pi-ellipsis-v"
                    (click)="selectedAction = data; srchRowActionPanel.toggle($event)">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-overlayPanel #srchRowActionPanel appendTo="body">
    <ng-template pTemplate>
      <div class="mob-action-list">
        <button pButton type="button" class="p-button-outlined mob-action-item"
                icon="pi pi-pencil" label="Edit Booking"
                (click)="editdatanew(selectedAction?.bookingId); srchRowActionPanel.hide()">
        </button>
        <button pButton type="button" class="p-button-outlined p-button-danger mob-action-item"
                icon="pi pi-calendar-times" label="Disable Booking"
                (click)="disableData(selectedAction?.bookingId); srchRowActionPanel.hide()">
        </button>
      </div>
    </ng-template>
  </p-overlayPanel>

</div>

<!-- ── Desktop view ────────────────────────────────────────── -->
<div *ngIf="!useMobileView && ListBookings" class="p-3 flex flex-column flex-auto">
    <h3 style="margin-bottom: -38px" i18n>Search Results</h3>

    <div style="text-align: right; margin-bottom: 20px;">

        <p-toggleButton class="p-button-sm p-button-danger p-component" [(ngModel)]="showDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal', 'height': '50px'}" (click)="toggleDisabled()">
        </p-toggleButton>

        <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
            <i class="pi pi-search"></i>
            <input pInputText type="text" placeholder="Filter Results" (input)="resourceTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" />
        </span>

    </div>
    <div class="surface-card p-4 shadow-2 border-round">
    <p-table  #resourceTable
    [first]=currentpage
    [value]="ListBookings" sortField="startTime" [paginator]="true" [rows]="10"
    [showCurrentPageReport]="true" responsiveLayout="scroll"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
    [rowsPerPageOptions]="[10,25,50]"
    [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName']"
    [(selection)]="selectedItem"
    responsiveLayout="scroll"
    datakey="resourceID"
    (onPage)="onPageChange($event)"
    [selectionPageOnly]="true">
        <ng-template pTemplate="header">
            <tr>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th pSortableColumn="bookingId" width="12%">Sales ID
                    <p-sortIcon [field]="bookingIdHR"></p-sortIcon>
                </th>
                <th pSortableColumn="startTime" width="12%">Start Date
                    <p-sortIcon [field]="startTime"></p-sortIcon>
                </th>
                <th pSortableColumn="startTime" width="10%">Start
                    <p-sortIcon [field]="startTime"></p-sortIcon>
                </th>
                <th pSortableColumn="name" width="10%">Name
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>
                <th pSortableColumn="packageName" width="11%">Package
                    <p-sortIcon [field]="packageName"></p-sortIcon>
                </th>
                <th pSortableColumn="guests" width="10%">Guests
                    <p-sortIcon [field]="guests"></p-sortIcon>
                </th>
                <th pSortableColumn="total" width="8%">Total
                    <p-sortIcon [field]="total"></p-sortIcon>
                </th>
                <th pSortableColumn="outstanding" width="8%">O/S
                    <p-sortIcon [field]="outstanding"></p-sortIcon>
                </th>
                <th width="5%"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" style="cursor:pointer" (click)="editdatanew(data.bookingId)">
                <td>
                    <span *ngIf="data.publicBooking" class="pi pi-user"></span>
                </td>
                <td>
                    <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                </td>
                <td>
                    <span style="color:red" *ngIf="data.awaitingpayment" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                </td>
                <td>
                    <!-- A repeatable package books one date per booking, all sharing a seriesid. -->
                    <span *ngIf="data.seriesid" class="pi pi-sync" pTooltip="One of a series of repeat bookings"></span>
                </td>
                <td>{{data.bookingIdHR}}</td>
                <td>{{data.startTime | date:'dd/MM/yy'}}</td>
                <td>{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                <td>{{data.name}}</td>
                <td>{{data.packageName}}</td>
                <td>{{data.guests}}</td>
                <td>{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                <td *ngIf="data.outstanding <=0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                <td *ngIf="data.outstanding >0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                <td (click)="$event.stopPropagation()"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableData(data.bookingId)" i18>
                    <span class="pi pi-calendar-times" style="margin-right:8px;"></span>
                    <span i18n>Disable</span>
                </button></td>
            </tr>
        </ng-template>
    </p-table>
    </div>
</div>
